import React, { FC, PropsWithChildren } from 'react';

import { Product } from 'src/api/@generated/backend';

import { DataLayerWrapper } from 'src/components/data-layer-wrapper/data-layer-wrapper';
import { selectProductIndex } from 'src/state/order/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { DataLayerEvent } from 'src/types/data-layer-event-object';
import { DataLayerUtils } from 'src/utils/data-layer-utils';

interface Props {
  product: Product;
}

export const DataLayerViewItemWrapper: FC<PropsWithChildren<Props>> = (props) => {
  const { product, children } = props;
  const selectedProductIndex = useAppSelector(selectProductIndex(product));

  return (
    <DataLayerWrapper
      pushToDataLayer={() =>
        DataLayerUtils.pushToProductDataLayer(DataLayerEvent.VIEW_ITEM, product, selectedProductIndex)
      }
    >
      {children}
    </DataLayerWrapper>
  );
};
